import { render } from "./who_to_follow_panel.vue?vue&type=template&id=755c2db7"
import script from "./who_to_follow_panel.js?vue&type=script&lang=js&external"
export * from "./who_to_follow_panel.js?vue&type=script&lang=js&external"

import "./who_to_follow_panel.vue?vue&type=style&index=0&id=755c2db7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__